import React, { useState } from "react";
import { Box, Typography, Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import AdminUserList from "../components/AdminUserList";
import AdminUserProfile from "../components/AdminUserProfile";
import AdminProfilePictureApprovals from "../components/AdminProfilePictureApprovals";

export default function AdminUsersPage({ onBack }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <Box sx={{ maxWidth: 1200, mx: "auto", mt: { xs: 2, sm: 4 }, p: { xs: 1, sm: 3 } }}>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'stretch', sm: 'center' }, mb: 2, gap: { xs: 1, sm: 0 } }}>
        <Typography variant="h4" flexGrow={1} sx={{ fontSize: { xs: 22, sm: 28 } }}>User Management</Typography>
        {onBack && <Button onClick={onBack} variant="outlined" sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 1, sm: 0 } }}>Back to Dashboard</Button>}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 2, md: 4 }, alignItems: { xs: 'stretch', md: 'flex-start' } }}>
        <Box sx={{ flex: 1, minWidth: 0, mb: { xs: 2, md: 0 } }}>
          <AdminUserList onUserClick={setSelectedUser} reloadKey={reloadKey} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <AdminProfilePictureApprovals />
        </Box>
      </Box>
  <Dialog open={!!selectedUser} onClose={() => setSelectedUser(null)} maxWidth="sm" fullWidth>
        <DialogTitle>
          User Profile
          <IconButton
            aria-label="close"
            onClick={() => setSelectedUser(null)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedUser && (
            <AdminUserProfile
              user={selectedUser}
              onClose={() => setSelectedUser(null)}
              onDeleted={() => { setSelectedUser(null); setReloadKey(k => k + 1); }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
